// returns the number of default decimals for each unit
import type { UNITS } from '@/app/common/measures/types.ts';
import { DISTANCE_UNITS, WEIGHT_UNITS } from '@/app/common/measures/types.ts';

export const getDecimals = (unit: UNITS, override?: number): number => {
  if (override !== undefined) return override; // Use the override value if provided

  switch (unit) {
    case DISTANCE_UNITS.KM:
    case DISTANCE_UNITS.MI:
    case WEIGHT_UNITS.OZ:
      return 2; // Travel distances: 5.25 km, 3.14 mi
    case WEIGHT_UNITS.KG:
    case WEIGHT_UNITS.LBS:
      return 1; // Body weight, luggage: 70.5 kg, 155.2 lbs
    case DISTANCE_UNITS.M:
    case DISTANCE_UNITS.FT:
    case WEIGHT_UNITS.G:
      return 0; // Building measurements, food portions: 325 m, 6 ft, 250 g
    default:
      return 2; // Default to 2 decimals for any unrecognized unit
  }
};

export const applyDecimals = (value: number, decimals: number): number => {
  if (decimals === undefined || decimals === null || decimals < 0) return value;
  return parseFloat(value.toFixed(decimals));
};
